var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod_privilege_slide"},[_c('Privilege',{attrs:{"title":'VIP特权'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }